export default {
  install(Vue) {

    Vue.prototype.$handleSaveError = function(error) {
      if (error.response && error.response.status === 400) {
        const message = error.response.data.title === undefined ? error.response.data.message : error.response.data.title;
        this.$notifySaveError(message);
      } else if (error.response && error.response.status === 409) {
        this.$notifyConcurrencyError();
      }
      else {
        this.$notifySaveError(error.message);
      }
    }
  }
};